import { instance as axios, setJwtToken } from "../../config/axiosInstance";

// ---------------------login----------------------------------
export const loginApi = async (data) => {
  return await axios.post("admin/auth/login", data);
};
// ---------------------logout----------------------------------
export const logoutApi = async () => {
  return await axios.get("admin/auth/logout", setJwtToken());
};
// ---------------------forget-password------------------------------
export const forgetApi = async (data) => {
  return await axios.post(`admin/auth/forgot-password`, data);
};
// ---------------------verify-forget-password------------------------------
export const verifyForgotPasswordApi = async (data) => {
  return await axios.post(`admin/auth/verify-forgot-password`, data);
};
// ---------------------update-password------------------------------
export const updatePasswordApi = async (data) => {
  return await axios.post(`admin/auth/update-password`, data);
};




// ---------------------Verify Otp----------------------------------
export const verifyOtpApi = async (data) => {
  return await axios.post("admin-auth/verify-otp", data);
};
// ---------------------Resend Otp----------------------------------
export const resendOtp = async (data) => {
  return await axios.post("admin-auth/resend-otp", data);
};

// ---------------------reset-password---------------------------------
export const resetPasswordApi = async (data) => {
  return await axios.post("admin-auth/reset-password", data);
};
